import { FileTypes } from "../../../constants/enums";

/**
 * Determine ingestion type based on ingestionListItem properties
 * @param ingestionListItem - ingestion list item
 * @param {string} defaultIngestionType - default ingestion type
 * @returns {string}  - ingestion type
 */
export const getIngestionListItemType = (ingestionListItem, defaultIngestionType) => {
  const reDocx = /docx/i;
  return reDocx.test(ingestionListItem.ingestionStats) ? FileTypes.DOCX : defaultIngestionType;
};
